// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import store from "./redux/store";

import Sidebar from "./components/Sidebar";
import "./App.css";
import "./styles/theme.css"; // Global dashboard theme
import Projects from "./components/Projects";
import Leads from "./components/Leads";
import LiveLeads from "./components/LiveLeads";
import BlockedIPs from "./components/BlockedIPs";
import Settings from "./components/Settings";
import Dashboard from "./components/Dashboard";
import LoginPage from "./pages/LoginPage";
import Logout from "./components/Logout";
import { WebSocketProvider } from "./context/WebSocketContext";
import ProjectDetails from "./pages/ProjectDetails";
import ToastProvider from "./provider/ToastProvider";
import Visitor from "./components/visit-logs";
import Monitor from "./components/Monitor";
import RoleAccess from "./components/RoleAccess";
import InstallationPage from "./pages/InstallationPage";
import SEO from "./components/SEO";
import AnalysisPage from "./pages/AnalysisPage";
import ErrorBoundary from "./components/ErrorBoundary";
import Tools from "./components/Tools";
import SystemLogs from "./components/SystemLogs";

// ----------------------
// Route Wrappers
// ----------------------
function PrivateRoute({ children }) {
  const { user } = useSelector((state) => state.auth);
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function PublicRoute({ children }) {
  const { user } = useSelector((state) => state.auth);
  return user ? <Navigate to="/" replace /> : children;
}

// ----------------------
// App Component
// ----------------------
function App() {
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <WebSocketProvider>
          <ToastProvider />
          <Router>
            <Routes>
              {/* Public Routes */}
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <LoginPage />
                  </PublicRoute>
                }
              />

              {/* Logout Route */}
              <Route path="/logout" element={<Logout />} />

              {/* Private Routes */}
              <Route
                path="/*"
                element={
                  <PrivateRoute>
                    <div className="d-flex">
                      <Sidebar />
                      <div className="main-content flex-grow-1">
                        <Routes>
                          <Route path="/" element={<Dashboard />} />
                          <Route path="/projects" element={<Projects />} />
                          <Route
                            path="/project/:projectid"
                            element={<ProjectDetails />}
                          />
                          <Route path="/leads" element={<Leads />} />
                          <Route path="/live-leads" element={<LiveLeads />} />
                          <Route path="/blocked-ips" element={<BlockedIPs />} />
                          <Route path="/monitor" element={<Monitor />} />
                          <Route path="/settings" element={<Settings />} />
                          <Route path="/role-access" element={<RoleAccess />} />
                          <Route
                            path="/installation"
                            element={<InstallationPage />}
                          />
                          <Route path="/visit-logs" element={<Visitor />} />
                          <Route path="/seo" element={<SEO />} />
                          <Route path="/analysis" element={<AnalysisPage />} />
                          <Route path="/tools" element={<Tools />} />
                          <Route path="/system-logs" element={<SystemLogs />} />
                        </Routes>
                      </div>
                    </div>
                  </PrivateRoute>
                }
              />
            </Routes>
          </Router>
        </WebSocketProvider>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
